import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { Grid, withStyles, withWidth } from "@material-ui/core";
import getSymbolFromCurrency from 'currency-symbol-map';
import numeral from 'numeral';
import styled from 'styled-components';
import { isOtherShape } from 'logged_out/components/diamonds/All';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "./../../../../redux/actions/auth";
import * as DiamondsActions from "./../../../../redux/actions/diamonds";
import { convertToCurrency } from 'shared/functions/priceCalc';

const styles = theme => ({

});

function joinHenigArray(d, field) {
    return d[field] ? [d[field][0] && d[field][0].From, d[field][1] && d[field][1].To].filter(s => s).join(' to ') : ''
}

const RelatedOfferWrap = styled.div`
width: ${props => !props.isMobile ? props.isParcel ? '780px' : '620px' : '100%'};
background-color: #f8f9fa;
position: relative;
display: block;
float: ${props => !props.isMobile ? 'right' : 'none'};
margin-top: 54px;
padding-top: ${props => !props.isMobile ? '0' : '24px'};

  h3{
    font-family: Lato;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: 1.44px;
    text-align: left;
    color: #b6b8bc;
    margin-top: ${props => !props.isMobile ? '-25px' : '0'};
    margin-left: ${props => !props.isMobile ? 'auto' : '35px'};
  }

  img{
    cursor: pointer;
  }
  .specialOfferText{
    font-family: Lato;
    font-size: 13px;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.92;
    letter-spacing: normal;
    text-align: ${props => !props.isMobile ? 'left' : 'center'};;
    color: #f8f9fa;
    margin-right: 8px;
  
    h4{
      font-size: 13px;
      margin: 0;
      margin-top: 22px;
      margin-bottom: 8px;
      font-weight: 100;
      color: #24272b;
    }
    p{
      font-family: Lato;
      font-size: 11px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: center;
      color: #8d9298;
      margin: 0;

      .specialOffersTextSeparator{
        width: 1px;
        height: 14px;
        background-color: #8d9298;
        display: inline-block;
        margin-left: 6px;
        margin-right: 6px;
        vertical-align: middle;
      }
    }
  }
`;

function RelatedItem(props) {
    const { items, isAuthorised, ccy, onItemClick, isMobile, isParcel, fxrates=[] } = props;
    return (<Grid container style={{ paddingLeft: 50, paddingRight: 40, paddingTop: 10 }}>
        {items.map((row, i) => <Grid item xs={isMobile ? 6 : 4}>
            <Grid container alignItems="center" direction={isMobile ? 'column' : 'row'}>
                <Grid item style={{ paddingRight: !isMobile ? 10 : 0 }}>
                    <img alt="" className="diamond-img" src={row.img} width={isMobile ? 120 : 40} onClick={() => onItemClick(row)} />
                </Grid>
                <Grid item>
                    <span className={'specialOfferText'} onClick={() => onItemClick(row)}>
                        <h4>
                            {!isAuthorised && !row.specialOffer && ''}
                            {(isAuthorised || row.specialOffer) && getSymbolFromCurrency(ccy) + numeral(Math.round(convertToCurrency(row.price, row.isParcel, fxrates, ccy))).format('0,0.00')}
                        </h4>
                        <p>
                            {row.isParcel ? row.size || '-' : `${numeral(row.STWeight).format('0.00')}ct`} <span className="specialOffersTextSeparator" /> {joinHenigArray(row, 'Colour') || '-'} {(!isMobile || (isMobile && !isParcel)) ? <span className="specialOffersTextSeparator" /> : <br />} {joinHenigArray(row, 'Clarity') || '-'}
                        </p>
                    </span>
                </Grid>
            </Grid>
        </Grid>)}
    </Grid>
    )
}

function RelatedCarousel({ items = [], isAuthorised, ccy, onItemClick, isMobile, isParcel, fxrates=[] }) {

    // split items into groups of 3
    const myArray = [...items];
    var results = [];
    while (myArray.length) {
        results.push(myArray.splice(0, isMobile ? 2 : 3));
    }

    return (
        <Carousel
            autoPlay={false}
            /* animation="slide" */
            navButtonsWrapperProps={{
                backgroundColor: '#f8f9fa',
            }}
            navButtonsProps={{
                style: {
                    minWidth: 'auto',
                    height: 'auto',
                    backgroundColor: '#f8f9fa',
                    position: 'relative',
                }
            }}
            indicatorIconButtonProps={{
                style: {
                    display: 'none'
                }
            }}
            PrevIcon={<img alt="" src={'/images/icon_down@3x.png'} width={10} style={{ transform: 'rotate(90deg)', filter: 'brightness(0.4)' }} />}
            NextIcon={<img alt="" src={'/images/icon_down@3x.png'} width={10} style={{ transform: 'rotate(270deg)', filter: 'brightness(0.4)' }} />}
        >
            {results.map((items, i) => <RelatedItem key={i} items={items} isAuthorised={isAuthorised} ccy={ccy} fxrates={fxrates} onItemClick={onItemClick} isMobile={isMobile} isParcel={isParcel} />)}
        </Carousel>
    )
}

function mapDiamond(d, isParcel) {
    d.WebSpecial = parseFloat(d.WebSpecial)
    return {
        ...d,
        img: `/images/${isOtherShape(isParcel, d.StkShape) ? 'round' : d.StkShape.toLowerCase()}${isParcel ? '_parcel.png' : '.png'}`,
        imgSide: `/images/${isOtherShape(isParcel, d.StkShape) ? 'round' : d.StkShape.toLowerCase()}${isParcel ? '_parcel.png' : ' side.png'}`,
        colour: joinHenigArray(d, 'Colour'),
        clarity: joinHenigArray(d, 'Clarity'),
        cut: joinHenigArray(d, 'Cut'),
        flourecence: joinHenigArray(d, 'flourecence'),
        symmetry: joinHenigArray(d, 'Symmetry'),
        polish: joinHenigArray(d, 'Polish'),
        size: joinHenigArray(d, 'Size'),
        availability: d.Availability || d.StkWebAvailable,
        price: !isParcel ? (d.WebSpecial || d.price || d.ExWebTotal) : (d.WebSpecial || d.ppc),
        specialOffer: d.WebSpecial ? true : false,
    };
}

const RelatedOffer = (props) => {
    const { diamondId, diamondsData, isAuthorised, ccy, onItemClick, width, fxrates=[] } = props;

    if (!diamondsData) return '';

    const isMobile = width === 'xs';

    const d = diamondsData.docs.find(d => d._id === diamondId);
    const isParcel = d.StkCatType === 'Multiple Items' ? true : false;
    const related = diamondsData.docs.filter(x => x.StkShape === d.StkShape && x.StkCatType === d.StkCatType && x._id !== d._id).map(x => mapDiamond(x, isParcel))

    return <RelatedOfferWrap isParcel={isParcel} isMobile={isMobile}>
        <h3>RELATED</h3>
        <RelatedCarousel items={related} isAuthorised={isAuthorised} ccy={ccy} fxrates={fxrates} onItemClick={onItemClick} isMobile={isMobile} isParcel={isParcel} />
    </RelatedOfferWrap>;
}

export default connect(
    (state) => ({
        authUser: state.auth.user,
        isAuthorised: state.auth.isAuthorised,
        diamondsData: state.diamonds.data,
        ccy: state.site.ccy,
        fxrates: state.site.fxrates,
    }),
    (dispatch) => ({
        AuthActions: bindActionCreators({ ...AuthActions }, dispatch),
        DiamondsActions: bindActionCreators({ ...DiamondsActions }, dispatch),
    })
)(withWidth()(withStyles(styles, { withTheme: true })(RelatedOffer)));
